import { Box } from './Box';

type BarChartPlotBordersProps = {
  bottom: number;
  color: string;
  left: number;
  right: number;
  showVerticalBorders: boolean;
  top: number;
};

export const BarChartPlotBorders = ({
  bottom,
  color,
  left,
  right,
  showVerticalBorders,
  top,
}: BarChartPlotBordersProps): JSX.Element => (
  <>
    <Box
      data-chart-axis="top"
      sx={{
        position: 'absolute',
        left: Math.max(0, left),
        right,
        top,
        height: '1px',
        backgroundColor: color,
        pointerEvents: 'none',
        zIndex: 2,
      }}
      aria-hidden="true"
    />
    {showVerticalBorders ? (
      <>
        <Box
          data-chart-axis="left"
          sx={{
            position: 'absolute',
            left: Math.max(0, left),
            top,
            bottom,
            width: '1px',
            backgroundColor: color,
            pointerEvents: 'none',
            zIndex: 2,
          }}
          aria-hidden="true"
        />
        <Box
          data-chart-axis="right"
          sx={{
            position: 'absolute',
            right,
            top,
            bottom,
            width: '1px',
            backgroundColor: color,
            pointerEvents: 'none',
            zIndex: 2,
          }}
          aria-hidden="true"
        />
      </>
    ) : null}
  </>
);
